import React from 'react';
import Toast from 'src/components/toast';
import Icon from 'shared/components/icon';
import TextButton from 'src/components/text-button';
import {useDispatch} from 'react-redux';

interface ActionNotificationProps {
  action: object;
  actionText: string;
  dismiss: () => void;
  strongText?: string;
  text: string;
  type: string;
}

const ActionNotification = ({
  dismiss,
  text,
  type,
  strongText,
  actionText,
  action,
}: ActionNotificationProps): React.ReactElement => {
  const dispatch = useDispatch();

  return (
    <Toast type={type} className="shared-notification-toast">
      <span className="shared-notifications-message-text">
        {strongText && (
          <strong className="shared-notifications-message-text-strong">{`${strongText} `}</strong>
        )}
        {`${text} `}
        <TextButton
          onClick={(): void => {
            dismiss();
            dispatch(action);
          }}
          color="white"
          className="shared-notifications-message-text-action-button"
        >
          {actionText}
        </TextButton>
      </span>
      <Icon
        iconType="times-r"
        className="shared-notifications-dismiss-notification-button"
        onClick={dismiss}
      />
    </Toast>
  );
};

export default ActionNotification;
